import React, { Fragment } from 'react'
import { Tooltip, PieChart, Pie, Cell } from 'recharts';
import { H3 } from "@blueprintjs/core"

const PieComponent = ({ data, ratio, COLORS, left }) => {

    return (
        <div className={`pieRatioContainer ${left ? "leftPie" : ""}`}>
            {(data && data.length > 0) &&
                <Fragment>
                    <div className='pieLegend'>
                        <H3 className='margin-bottom-large new-results'>Indice d'ouverture: {ratio}</H3>
                        {data.map((res, i) => {
                            if (res.value > 0) {
                                return (
                                    <div key={i} className='pieSingleLegendContainer'>
                                        <div className='pieSingleLegend' style={{ backgroundColor: COLORS[i] }}>
                                            {res.name}
                                        </div>
                                        <span className='new-results'> {res.value.toFixed(2)} %</span>
                                    </div>
                                )
                            } else {
                                return null
                            }
                        })}
                    </div>
                    <div className="singlePie">
                        <PieChart width={300} height={400}>
                            <Pie
                                innerRadius={15}
                                data={data}
                                cx={80}
                                cy={200}
                                outerRadius={80}
                                fill="#8884d8"
                            >
                                {
                                    data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                                }
                            </Pie>
                            <Tooltip formatter={(value) => value === 0 ? '' : `${value.toFixed(2)} %`} />
                        </PieChart>
                    </div>
                </Fragment>
            }
        </div>
    )
}

export default PieComponent
